/**
 * @fileoverview Which server why-reasons a Discover surface may print
 * (WEB-1228, ruling R2).
 *
 * `PROXIMITY` (the proximity reason line) is measured from the query
 * center — the city anchor or a map redo center — never from the reader, so
 * no Discover surface prints it. Every other reason passes through unchanged
 * and in server order.
 *
 * @since WEB-1228
 */
import type { WhyReason } from '@loci/types';

export function listedWhyReasons(reasons: readonly WhyReason[] | undefined): readonly WhyReason[] {
  return (reasons ?? []).filter((reason) => reason.code !== 'PROXIMITY');
}
